import DishesPageView from "./DishesPageView";

function DishesPage() {
  return <DishesPageView />;
}

export default DishesPage;
